import RightConstellation from './RightConstellation';
import RightTerminal from './RightTerminal';
import RightDataFlow from './RightDataFlow';
import RightSplitView from './RightSplitView';
import RightBentoGrid from './RightBentoGrid';

export const VARIANTS = [
  RightConstellation,
  RightTerminal,
  RightDataFlow,
  RightSplitView,
  RightBentoGrid,
];

export const VARIANT_LABELS = [
  'Constellation',
  'Terminal',
  'Data Flow',
  'Split View',
  'Bento Grid',
];
